import React, { useState, useEffect } from "react";
import { FaRegImage } from "react-icons/fa";
import { AiOutlineDelete } from "react-icons/ai";
import GalleryLibraryModal from "./GalleryLibraryModal";
import { useDispatch } from "react-redux";
import {deleteTeamCoverImageRequest} from "../../store/TeamCoverImage/teamCoverImageActions"
import {deleteCoverImageRequest} from "../../store/CarecellCoverImage/carecellCoverImageActions"
import {deleteProgramCoverImageRequest} from "../../store/ProgramCoverImage/actions"
import {deleteBulletinCoverImageRequest} from "../../store/BulletinCoverImage/bulletinCoverImageActions"
import {deleteCampusGalleryRequest} from "../../store/Campuse/campusesActions"
import {deleteServiceGalleryRequest} from '../../store/Service/servicesActions'
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const GalleryPickerField = ({
  label,
  church,
  rowData,
  name,
  handleChange,
  autoSave = false,
  onAutoSave,
    resetTrigger,
    typeofentity
}) => {
  const [showModal, setShowModal] = useState(false);
  const [selectedImages, setSelectedImages] = useState([]);
 const dispatch =useDispatch();
  // ✅ Prefill images from rowData only once (when component mounts)

  // ✅ Clear selected images when resetTrigger changes
useEffect(() => {
  setSelectedImages([]);
  if (typeof handleChange === "function") {
    handleChange({ target: { name, value: [] } });
  }
}, [resetTrigger]);

useEffect(() => {
  let prefilled = [];
  if (rowData?.gallery?._id) {
    prefilled = [
      {
        id: rowData.gallery._id,
        name: rowData.gallery.imageName || "Unnamed Image",
        url: rowData.gallery.imageUrl || "",
        tabletsetting: rowData.tabletsetting || rowData.gallery.tabletsetting || "contain",
        mobilesetting: rowData.mobilesetting || rowData.gallery.mobilesetting || "fill",
        dashboardsetting: rowData.dashboardsetting || rowData.gallery.dashboardsetting || "cover",
        ...rowData.gallery,
      },
    ];
  }
  else if (rowData?.membercoverimage?.length > 0) {
    prefilled = rowData.membercoverimage.map((imgObj) => {
      const gallery = imgObj.gallery || {};
      return {
        id: gallery._id || imgObj.memberimageObjId,
        name: gallery.imageName || "Unnamed Image",
        url: gallery.imageUrl || "",
        tabletsetting: gallery.tabletsetting || "contain", // default to "contain"
        ...gallery,
      };
    });
  } else if (rowData?.carecellcoverImage?.length > 0) {
    prefilled = rowData.carecellcoverImage.map((imgObj) => {
      const gallery = imgObj.gallery || {};
      return {
        id: gallery._id || imgObj.carecellCoverImageObjId,
        name: gallery.imageName || "Unnamed Image",
        url: gallery.imageUrl || "",
        tabletsetting: gallery.tabletsetting || "contain",
        ...gallery,
      };
    });
  } else if (rowData?.programcoverImage?.length > 0) {
    prefilled = rowData.programcoverImage.map((imgObj) => {
      const gallery = imgObj.gallery || {};
      return {
        id: gallery._id || imgObj.programcoverimageObjId,
        name: gallery.imageName || "Unnamed Image",
        url: gallery.imageUrl || "",
        tabletsetting: gallery.tabletsetting || "contain",
        ...gallery,
      };
    });
  } else if (rowData?.bulletincoverImage?.length > 0) {
    prefilled = rowData.bulletincoverImage.map((imgObj) => {
      const gallery = imgObj.gallery || {};
      return {
        id: gallery._id || imgObj.bullitenimageObjId,
        name: gallery.imageName || "Unnamed Image",
        url: gallery.imageUrl || "",
        tabletsetting: gallery.tabletsetting || "contain",
        ...gallery,
      };
    });
  } else if (rowData?.campusgallery?.length > 0) {
    prefilled = rowData.campusgallery.map((imgObj) => {
      const gallery = imgObj.gallery || {};
      return {
        id: gallery._id || imgObj.campusGalleryObjId,
        name: gallery.imageName || "Unnamed Image",
        url: gallery.imageUrl || "",
        tabletsetting: gallery.tabletsetting || "contain",
        ...gallery,
      };
    });
  }
  else if (rowData?.servicegallery?.length > 0) {
    prefilled = rowData.servicegallery.map((imgObj) => {
      const gallery = imgObj.gallery || {};
      return {
        id: gallery._id || imgObj.serviceGalleryObjId,
        name: gallery.imageName || "Unnamed Image",
        url: gallery.imageUrl || "",
        tabletsetting: gallery.tabletsetting || "contain",
        ...gallery,
      };
    });
  }
  setSelectedImages(prefilled);

  // Notify parent once to initialize field value
  if (typeof handleChange === "function") {
    handleChange({ target: { name, value: prefilled } });
  }
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [rowData]);


 // ⬅️ run once only (no re-render loops)

  // ✅ Handle new image selection from modal
  const handleImageSelect = (imgOrArray) => {
    const incoming = Array.isArray(imgOrArray)
      ? imgOrArray
      : [imgOrArray];

    setSelectedImages((prev) => {
      const merged = [
        ...prev,
        ...incoming.filter(
          (img) => !prev.some((p) => p.id === img.id)
        ),
      ];

      if (typeof handleChange === "function") {
        handleChange({ target: { name, value: merged } });
      }

      if (autoSave && typeof onAutoSave === "function") {
        onAutoSave(merged);
      }

      return merged;
    });

    setShowModal(false); // ✅ closes ONCE
  };


  // ✅ Handle image deletion

// ✅ Handle image deletion (with full row console log)
 // ✅ Image delete handler (with API integration)
 const handleDeleted = (imgSet, index) => {

  let apiPayloadRequest = null;
  let dispatchAction = null;

  // 🔹 MEMBER COVER IMAGE DELETE
  if (rowData?.membercoverimage?.some((item) => item?.gallery?._id === imgSet?._id)) {
    const matched = rowData.membercoverimage.find(
      (item) => item?.gallery?._id === imgSet?._id
    );
    apiPayloadRequest = {
      _id: church?._id ,
      memberObjId: rowData?._id || rowData?.memberObjId,
      memberimageObjId: matched?.memberimageObjId,
    };
    dispatchAction = deleteTeamCoverImageRequest;
  }

  // 🔹 CARECELL COVER IMAGE DELETE
  else if (rowData?.carecellcoverImage?.some((item) => item?.gallery?._id === imgSet?._id)) {
    const matched = rowData.carecellcoverImage.find(
      (item) => item?.gallery?._id === imgSet?._id
    );


    apiPayloadRequest = {
      _id: church?._id,
      carecellObjId: rowData?.carecellObjId,
      carecellCoverImageObjId: matched?.carecellCoverImageObjId,
    };
    dispatchAction = deleteCoverImageRequest;
  }

  // 🔹 PROGRAM COVER IMAGE DELETE
// 🔹 PROGRAM COVER IMAGE DELETE (handles both cases: programcoverImage or programcoverimage)
else if (
  rowData?.programcoverImage?.some((item) => item?.gallery?._id === imgSet?._id) ||
  rowData?.programcoverimage?.some((item) => item?.gallery?._id === imgSet?._id)
) {
  const matched =
    rowData?.programcoverImage?.find((item) => item?.gallery?._id === imgSet?._id) ||
    rowData?.programcoverimage?.find((item) => item?.gallery?._id === imgSet?._id);


  apiPayloadRequest = {
    _id: church?._id || localStorage.get("church_id"),
    programObjId: rowData?.programObjId,
    programcoverimageObjId: matched?.programcoverimageObjId,
  };
  dispatchAction = deleteProgramCoverImageRequest;
}
else if (
  rowData?.bulletincoverImage?.some((item) => item?.gallery?._id === imgSet?._id) ||
  rowData?.bulletincoverimage?.some((item) => item?.gallery?._id === imgSet?._id)
) {
  const matched =
    rowData?.bulletincoverImage?.find((item) => item?.gallery?._id === imgSet?._id) ||
    rowData?.bulletincoverimage?.find((item) => item?.gallery?._id === imgSet?._id);


  apiPayloadRequest = {
    _id: church?._id ,
    bulletinObjId: rowData?.bulletinObjId,
    bullitenimageObjId: matched?.bullitenimageObjId,
  };
  dispatchAction = deleteBulletinCoverImageRequest;
}
else if (
  rowData?.campusGallery?.some((item) => item?.gallery?._id === imgSet?._id) ||
  rowData?.campusgallery?.some((item) => item?.gallery?._id === imgSet?._id)
) {
  const matched =
    rowData?.campusGallery?.find((item) => item?.gallery?._id === imgSet?._id) ||
    rowData?.campusgallery?.find((item) => item?.gallery?._id === imgSet?._id);


  apiPayloadRequest = {
    _id: church?._id , // churchId
    campusObjId: rowData?.campusObjId, // campus id
    campusGalleryObjId: matched?.campusGalleryObjId, // gallery relation id
  };
    dispatchAction = deleteCampusGalleryRequest;
}
else if (rowData?.servicegallery?.some((item) => item?.galleryObjId === imgSet?._id)) {
  const matched = rowData.servicegallery.find((item) => item?.galleryObjId === imgSet?._id);


  apiPayloadRequest = {
    _id: church?._id , // Church Obj ID
    serviceObjId: rowData?.serviceObjId, // Service Obj ID
    serviceGalleryObjId: matched?.serviceGalleryObjId, // Service Gallery Obj ID
  };

  dispatchAction = deleteServiceGalleryRequest;
}
  // 🔹 No match found
// 🔹 No match found
else {

  // Remove image locally
  const updated = selectedImages.filter((_, i) => i !== index);
  setSelectedImages(updated);

  // Update parent
  if (typeof handleChange === "function") {
    handleChange({ target: { name, value: updated } });
  }

  toast.info("Image removed locally.");

  return;  // stop further execution (no API call)
}



  if (!dispatchAction) {
    toast.error("Delete action not found!");
    return;
  }

  // 🔹 Dispatch the delete request
  dispatch(
    dispatchAction({
      apiPayloadRequest,
      callback: (res) => {
                if (res.type === 1) {
          toast.success("Image deleted successfully!");
          const updated = selectedImages.filter((_, i) => i !== index);
          setSelectedImages(updated);
          if (typeof handleChange === "function") {
            handleChange({ target: { name, value: updated } });
          }
        } else {
          toast.error(res.error || "Delete failed!");
        }
      },
    })
  );
};





  return (
    <div className="flex flex-col gap-2 my-4 w-full max-w-[99%]">
      <div className="flex items-center justify-between">
        <label className="text-[12px] text-greyish font-medium">{label}</label>
        <button
          onClick={() => setShowModal(true)}
          className="text-white hover:text-gray-300 flex items-center"
        >
          <FaRegImage size={18} className="mr-2" /> Select Image
        </button>
      </div>

      {/* Selected images */}
      <div className="bg-[#1b1b1b] border border-[#333] rounded-lg p-3 w-full flex flex-col gap-2">
        {selectedImages.length > 0 ? (
          selectedImages.map((imgSet, index) => (
            <div
              key={imgSet.id || index}
              className="flex items-center justify-between bg-[#131313] border border-[#333] rounded-lg px-3 py-2"
            >
              <div className="flex items-center gap-3">
                <FaRegImage className="text-white w-5 h-5" />
                <span className="text-white text-sm font-medium truncate">
                  {imgSet.name}
                </span>
              </div>
              <button
        onClick={() => handleDeleted(imgSet, index)} // ✅ pass full image row
        className="text-white hover:text-red-500 rounded-full p-1"
              >
                <AiOutlineDelete size={18} />
              </button>
            </div>
          ))
        ) : (
          <span className="text-greyish text-sm">No image selected</span>
        )}
      </div>

      {/* Modal */}
      {showModal && church?._id  && (
        <GalleryLibraryModal
          isOpen={showModal}
          onClose={() => setShowModal(false)}
          church={church}
          typeofentity={typeofentity}
          handleGallerySelect={handleImageSelect}
        />
      )}
    </div>
  );
};

export default GalleryPickerField;
